/**
 * Created by Languagenut on 16/04/2019.
 */

import React  from 'react';

import {ProgressBar , Button , Navbar  , Nav , NavDropdown, Row, Col} from 'react-bootstrap'
import ClassesService from '../../services/classes-service.js';
import ProductService from '../../services/product-service.js';
import AssignmentService from '../../services/assignments-service.js';
import ClassStore from '../../store/classes-store.js';
import AssignmentStore from '../../store/assignment-store.js';
import Constants from '../../constants.js';
import Translation from '../../store/internationalization-store.js';
import Table from '../../components/general_table.js';
import Favourite from '../../components/favorite_button.js';
import LanguageSelect from '../../components/language_select.js';
import InformationPopup from '../popup/information_popup.js'
import Popup from '../../components/popup/comfirmation_popup.js'
import FieldGroup from '../../components/FieldGroup.js';
import {AccountService} from '../../services';
import UserStore from '../../store/user-store.js';

export default class Assignments extends React.Component {

    constructor(props) {
        super();
        this.props = props;
        this.state = {
            tab:"active",
            toggle:false,
            assignments:ClassStore.assignments || [],
            archivedLanguages:UserStore.archivedLanguages || [],
            archived:ClassStore.archived || [],
            hasLoaded:false,
            library:[],
            gotLibrary:false,
        };
    } 

    componentWillMount(){
        ProductService.getAllLanguages();
        AssignmentStore.on(Constants.GET_ASSIGNMENT_LIBRARY , ()=> {
            var x = AssignmentStore.assignmentLibrary;
            this.setState({
                library:AssignmentStore.assignmentLibrary|| [],
                gotLibrary:true
            })
        })
        ClassStore.on(Constants.GET_CLASS_ASSIGNMENTS , ()=>{
            this.setState({
                assignments:ClassStore.assignments|| [],
                archived:ClassStore.archived || [],
                archivedLanguages:UserStore.archivedLanguages || [],
                hasLoaded:true
            })
        })

        ClassStore.on(Constants.GET_CLASS_ARCHIVED_ASSIGNMENTS , ()=>{

            this.setState({
                archived:ClassStore.archived || [],
                hasLoaded:true
            })
        })

        ClassStore.on(Constants.GET_CLASS_FAV_ASSIGNMENTS , ()=>{

            function compare(a, b) {
                const aa = a.name.toUpperCase();
                const bb = b.name.toUpperCase();

                let comparison = 0;
                if (aa > bb) {
                    comparison = 1;
                } else if (aa < bb) {
                    comparison = -1;
                }
                return comparison;
            }
              
            var favs = ClassStore.favs.slice(0).sort(compare);

            this.setState({
                favs:favs|| [],
            })
        })
    }

    componentDidMount(){
        ProductService.getAllLanguages();
        ClassesService.getClassesAssignments(this.props.classID);
        ClassesService.getClassFavourite(this.props.classID);
        ClassesService.getClassesArchivedAssignments(this.props.classID);
    }

    handleSelect(eventKey){
        this.setState({tab:eventKey})
    }

    onClick(){
        this.setState({
            toggle:!this.state.toggle,
        })
    }

    getBody()
    {
        switch(this.state.tab)
        {
            case "students" : return <h4>Students</h4>
            case "staff" : return <h4>Students</h4>
        }
    }

    renderOptions(cell, row){

        return <NavDropdown className="pull-right" style={{padding:'0px' , margin:'0px'}} drop={"down"} title="Options" id="basic-nav-dropdown">
            <NavDropdown.Item href="#action/3.4">Assignment</NavDropdown.Item>
            <NavDropdown.Divider />
            <NavDropdown.Item href="#action/3.3">Edit</NavDropdown.Item>
            <NavDropdown.Item href="#action/3.3">Duplicate</NavDropdown.Item>
            <NavDropdown.Item href="#action/3.3">Share</NavDropdown.Item>
            <NavDropdown.Item href="#action/3.3">Archive</NavDropdown.Item>
            <NavDropdown.Item href="#action/3.3">Delete</NavDropdown.Item>
        </NavDropdown>

    }

    createAssignment(){
        window.location.hash = 'assignments/create'
    }

    renderProfileLink(cell, row){

        return <a href={"#/assignments/overview/"+row.id}>{cell}</a>
    }

    renderProfileLibraryLink(cell, row){
        if (row.isLibraryLink == 1) {
            return <a href={"#/assignments/library/"+row.homework_uid+"/"+row.curriculum_uid+"/"+row.languageCode}>{cell}</a>
        } else {
            return <a href={"#/assignments/libraryFake/"+row.id}>{cell}</a>
        }
    }

    renderAvailability(cell, row){
        return <div>{(new Date(cell.replace(" ", "T"))).format('d-m-y')}</div>
    }

    isAvailible(cell, row){
        if (cell == 1) {
            return <div><label style={{width:"50%", margin:"auto"}} class="b-contain">
                    <input disabled={true} checked={true} type="checkbox"/>
                    <div class="b-input"></div>
                </label></div>
        }
        return <div><label style={{width:"50%", margin:"auto"}} class="b-contain">
                <input disabled={true} checked={false} type="checkbox"/>
                <div class="b-input"></div>
            </label></div>
    }

    updateFav(toggle , uid){

        ClassesService.updateFav(toggle == "1" ? "0" : "1" , uid).then(function(){
            ClassesService.getClassFavourite(this.props.classID);
        }.bind(this))
    }

    updateFavLibrary(toggle , row){

        ClassesService.updateFavLibrary((toggle == "1" || toggle == true) ? "1" : "0" , row.homework_uid, row.curriculum_uid).then(function(){
            ClassesService.getClassFavourite(this.props.classID);
        }.bind(this))
    }

    renderTime(cell, row){

        function secondsToHms(d) {
            d = Number(d);
            if (d ==0) {
                return "-"
            }
            var h = Math.floor(d / 3600);
            var m = Math.floor(d % 3600 / 60);
            var s = Math.floor(d % 3600 % 60);

            if (h < 9) {
                h = "0"+h;
            }
            if (m < 9) {
                m = "0"+m;
            }
            if (s < 9) {
                s = "0"+s;
            }


            var hDisplay = h > 0 ? h + (h == 1 ? " hour, " : " hours, ") : "";
            var mDisplay = m > 0 ? m + (m == 1 ? " minute, " : " minutes, ") : "";
            var sDisplay = s > 0 ? s + (s == 1 ? " second" : " seconds") : "";

            return h +"h:"+ m +"m";
        }

        return secondsToHms(cell);
    }

    onLanguageChange(language){
        this.setState({
            gotLibrary:false
        })
        this.libraryLanguage = language;
        AssignmentService.getAssignmentLibrary(language.curriculumUid,language.ietf);
    }

    render(){

        if (!this.state.hasLoaded) {
            return <ProgressBar animated now={45}/>;
        }

        var popup = <Popup oneButton={true} buttonTitle={Translation.get(12787, "Send")} title={Translation.get(12788, "Assignment Message")} 
        onSave={()=>{
            AccountService.createMessageAssignment(this.state.messageTitle, this.state.messageMessage, this.state.assignmentUid)
            this.setState({addMessage:false});
        }} 
        onHide={()=>{
            this.setState({addMessage:false});
        }} 
        show={this.state.addMessage} 
        body={<div>
                <Row >
                    <Col sm={{span: 12}}>
                        <FieldGroup value={this.state.messageTitle} 
                                onSelect={(event)=>{
                                    this.setState({lastSelected:event.target, lastSelectType:"title", lastPosition:undefined});
                                }} 
                                onChange={(event)=>{ this.setState({messageTitle:event.target.value}) }} 
                                className="strong" as="input" label={Translation.get(2202, 'Title')}  type="input" autofocus="true"/>
                    </Col>
                </Row>
                <Row >
                    <Col sm={{span: 12}}>
                        <FieldGroup value={this.state.messageMessage} 
                                    onSelect={(event)=>{
                                        this.setState({lastSelected:event.target, lastSelectType:"message", lastPosition:undefined});
                                    }} 
                                    onChange={(event)=>{ this.setState({messageMessage:event.target.value}) }} 
                                    className="strong" as="input" label={Translation.get(12778, 'Subject')}  type="input" as="textarea" rows="3" />
                    </Col>
                </Row>
                {AccountService.getEmojiData(this)}
            </div>} />

       const columns = [
        {
            dataField: 'favourite',
            text: '',
            formatter: (cell , row)=>{
                console.log(cell)
                return <center onClick={this.updateFav.bind(this , cell , row.id)}><Favourite toggle={cell == "1"} /></center>
            }
        },{
            dataField: 'name',
            text: Translation.get(14 , 'Name'),
            hidden: true,
            sort:true,
            searchable: true,
        },{
            dataField: 'name',
            text: Translation.get(2008 , 'Assignment Name'),
            formatter: this.renderProfileLink.bind(this),
            sort:true,
            searchable: false,
        },{
            dataField: 'tasks',
            text: Translation.get(12607 , 'Total Tasks Set'),
            formatter: (cell)=>{
                return <div style={{width:"50%", margin:"auto"}}>{Number(cell.length)}</div>
            },
            headerStyle: (colum, colIndex) => {
                return { width: '125px', textAlign: 'left' };
            },
           searchable: false,
        },{
            dataField: 'language',
            text: Translation.get(492 , 'Language'),
            sort:true,
            formatter: (cell)=>{
                return Translation.get(cell , 'Language')
            },
           searchable: false,
        },{
            dataField: 'set',
            text: Translation.get(12608 , 'Set Date'),
            align:'left',
           sort:true,
            formatter: this.renderAvailability.bind(this),
           searchable: false,
        },{
            dataField: 'due',
            text: Translation.get(12104 , 'Due Date'),
            align:'left',
           sort:true,
            formatter: this.renderAvailability.bind(this),
           searchable: false,
        },{
            dataField: 'isRepeatable',
            text: Translation.get(12609 , 'Is Repeatable'),
            align:'left',
            sort:true,
            formatter: this.isAvailible.bind(this),
           searchable: false,
        },{
            dataField: 'message',
            text:"",
            csvExport: false,
            formatter: (cell, row)=>{
                return <div onClick={function() {
                    console.log(row);
                    this.setState({addMessage:true, messageMessage:"", messageTitle:row.name, assignmentUid:row.id});
                }.bind(this)}><i class="fas fa-envelope"></i></div>;
            }
        },{
            dataField: 'estimated_time',
            text: Translation.get(2414 , 'Estimated Time'),
            align:'center',
            formatter: this.renderTime.bind(this),
            searchable: false,
            headerStyle: (colum, colIndex) => {
                return { width: '140px', textAlign: 'center' };
            }
         }];

        const columns2 = [
        {
            dataField: 'favourite',
            text: '',
            formatter: (cell , row)=>{
                console.log(cell)
                return <center onClick={function() {
                    if (cell == undefined || cell == false || cell == "0") {
                        cell = "1";
                    } else {
                        cell = "0";
                    }
                    this.updateFavLibrary(cell, row)
                }.bind(this)}><Favourite toggle={cell == "1"} /></center>
            }
        },{
            dataField: 'tags',
            text: Translation.get(-1 , 'tags'),
            hidden: true,
            searchable: true,
        },{
            dataField: 'title',
            text: Translation.get(14 , 'Name'),
            hidden: true,
            sort:true,
            searchable: true,
        },{
             dataField: 'title',
             text: Translation.get(2008 , 'Assignment Name'),
             formatter: this.renderProfileLibraryLink.bind(this),
             sort:true,
             searchable: false,
         },{
             dataField: 'description',
             text: Translation.get(2203 , 'Description'),
             searchable: true,
         },{
            dataField: 'tasks',
            text: Translation.get(12607 , 'Total Tasks Set'),
            formatter: (cell)=>{
                return <div style={{width:"50%", margin:"auto"}}>{Number(cell.length)}</div>
            },
            headerStyle: (colum, colIndex) => {
                return { width: '125px', textAlign: 'center' };
            },
            align:'center',
            searchable: false,
        },{
            dataField: 'estimated_time',
            text: Translation.get(2414 , 'Estimated Time'),
            align:'center',
            formatter: this.renderTime.bind(this),
            searchable: false,
            headerStyle: (colum, colIndex) => {
                return { width: '140px', textAlign: 'center' };
            }
         }];

         const columns3 = [
            {
                dataField: 'favourite',
                text: '',
                formatter: (cell , row)=>{
                    return <center><Favourite toggle={true} stopToggle={true}/></center>
                }
            },{
                dataField: 'name',
                text: Translation.get(14 , 'Name'),
                hidden: true,
                sort:true,
                searchable: true,
            },{
                 dataField: 'name',
                 text: Translation.get(2008 , 'Assignment Name'),
                 formatter: this.renderProfileLibraryLink.bind(this),
                 sort:true,
                 searchable: false,
             },{
                 dataField: 'description',
                 text: Translation.get(2203 , 'Description'),
                 searchable: true,
             },{
                dataField: 'tasks',
                text: Translation.get(12607 , 'Total Tasks Set'),
                formatter: (cell)=>{
                    return <div style={{width:"50%", margin:"auto"}}>{Number(cell.length)}</div>
                },
                headerStyle: (colum, colIndex) => {
                    return { width: '125px', textAlign: 'center' };
                },
                align:'center',
                searchable: false,
            },{
                dataField: 'estimated_time',
                text: Translation.get(2414 , 'Estimated Time'),
                formatter: this.renderTime.bind(this),
                searchable: false,
                align:'center',
                headerStyle: (colum, colIndex) => {
                    return { width: '140px', textAlign: 'center' };
                }
             }];

        let fd = <Button className="float-right" onClick={this.createAssignment.bind(this)}>{Translation.get(12610 , 'Create an Assignment')}</Button>
            var navItemLibrary =  ""
        if (this.state.archivedLanguages != undefined && this.state.archivedLanguages.length > 0) {
            navItemLibrary =  <Nav.Item>
            <Nav.Link style={{paddingLeft:"10px"}} eventKey="library">{Translation.get(2415 , 'Assignments Library')}</Nav.Link>
            </Nav.Item>
        }

        let secondcomponent = <Navbar style={{marginTop:'-8px'}}>
            <Nav defaultActiveKey={this.state.tab} onSelect={k => this.handleSelect(k)}>
            <Nav.Item>
            <Nav.Link style={{paddingLeft:"0"}} eventKey="active">{Translation.get(12412 , 'Active Assignments')}</Nav.Link>
            </Nav.Item>
                &nbsp;  &nbsp;  &nbsp;
            <Nav.Item>
            <Nav.Link style={{paddingLeft:"0"}} eventKey="lessons">{Translation.get(12549 , 'Past Assignments')}</Nav.Link>
            </Nav.Item>
                &nbsp;  &nbsp;  &nbsp;
            <Nav.Item>
                <Nav.Link style={{paddingLeft:"0"}} eventKey="favorite">{Translation.get(12611 , 'Favourite Assignments')}</Nav.Link>
            </Nav.Item>
            {navItemLibrary}
            </Nav>
        </Navbar>


        var tables = <Table hideDownload secondary={secondcomponent} component={fd} bordered={ true } key='id' data={this.state.tab == 'active' ? this.state.assignments : this.state.archived} columns={ columns } />
        
        if (this.state.tab == "library") {

            let table = <Table searchExtra={<span style={{paddingLeft:"10px", paddingTop:"10px"}}><i onClick={()=>{this.setState({information:true})}} class="fas fa-info-circle"></i></span>} hideDownload
                               secondary={secondcomponent} bordered={ true } key='id' data={ this.state.library} columns={ columns2 } />;

            if(!this.state.gotLibrary)
            {
                table = <ProgressBar animated now={45}/>;
            }

            tables = [
                <InformationPopup title={Translation.get(2416 , 'Search tips')} show={this.state.information} onHide={()=>{this.setState({information:false})}}>
                {Translation.get(2417, 'Search tips: search for age/level e.g. ‘KS4’, ‘year 9’ or ‘S1’, book/chapter titles e.g. ‘Studio 3 Rouge’ or topic e.g. ‘holidays’.')}
                </InformationPopup>,
                <LanguageSelect limitLanguages={this.state.archivedLanguages} style={{fontWeight:700}} returnValue={this.onLanguageChange.bind(this)} />,
                table
        ] 
        }

        if (this.state.tab == "favorite") {
            tables = [
                <Table hideDownload secondary={secondcomponent} component={fd} bordered={ true } key='id' data={ this.state.favs} columns={ columns3 } />
            ]
        }

        return <div>
            <div>
                {popup}
                {tables}
            </div>
        </div>
    }
}
